import { render } from "./BaseDialog.vue?vue&type=template&id=f1f502fa&scoped=true&ts=true"
import script from "./BaseDialog.vue?vue&type=script&lang=ts"
export * from "./BaseDialog.vue?vue&type=script&lang=ts"

import "./BaseDialog.vue?vue&type=style&index=0&id=f1f502fa&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.29_vue@3.5.27_typescript@5.9.3__webpack@5.105.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1f502fa"]])

export default __exports__